// @flow
import makeAsync from "common/utils/makeAsync"
import Loading from "common/components/Loading/Loading"

export const Account = makeAsync(
  () => import(/* webpackChunkName: "async/Account" */ "mmb/scenes/Account/Account"),
  {
    Loader: Loading,
  },
)

export const AccountBooking = makeAsync(
  () =>
    import(
      /* webpackChunkName: "async/AccountBooking" */ "mmb/scenes/AccountBooking/AccountBooking"
    ),
  {
    Loader: Loading,
    lazy: true,
  },
)

export const Starred = makeAsync(
  () => import(/* webpackChunkName: "async/Starred" */ "mmb/scenes/Starred/Starred"),
  {
    Loader: Loading,
    lazy: true,
  },
)
